import actionResponse, { ActionResponse } from '../ActionResponse';
import { GroupStore } from '@stores';
import apiResponse from '@stores/ApiResponse';

export class SendCustomGiftCardAction {
  constructor(private readonly store: GroupStore = new GroupStore()) {}

  public async Execute(cohortUserId: number, amount: number): Promise<ActionResponse> {
    // Validate amount
    if (!amount || amount <= 0) {
      return actionResponse.ValidationError('Amount must be greater than 0');
    }

    try {
      await apiResponse.handleApiResponse(() => this.store.SendCustomGoodyGift(cohortUserId, amount));
      return actionResponse.Success(`Custom gift card of $${amount} sent successfully`);
    } catch (err) {
      return actionResponse.HandleError(err);
    }
  }
}
